import styled from "styled-components";

export const WrapperStages = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled.div`
  padding: 0px 100px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 768px) {
    padding: 0px 20px;
  }
`;

export const Button = styled.div`
  width: fit-content;
  position: absolute;
  left: 5%;
  top: 13px;

  @media screen and (max-width: 1430px) {
    width: 200px;
  }

  @media screen and (max-width: 1330px) {
    width: fit-content;
    position: relative;
    left: 0;
    top: 0;
  }

  @media screen and (max-width: 768px) {
    padding: 0px 20px;
  }
`;

export const WrapperLoading = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;